import z from 'zod';
import {
  coerceBoolean,
  coerceLiteralNumberRequired,
  coerceOptionalPositiveNumber,
  FIRST_VERSION_TIMESTAMP,
  zodTDateIso,
  zodTDateISODate,
  zodTMoneyOptional,
  ZodVersionedMetadata
} from '~/lib/zod';
import { TenantCustomer } from '~/tenants/common/TenantPersona';
import { DisplayData } from '~/lib/model';

export const TwtCustomerSchema = {
  [FIRST_VERSION_TIMESTAMP]: z.object({
    version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
    notes: z.string().optional(),
    address: z.string().optional(),
    announcement_send: coerceBoolean().optional(),
    announcement_sent: zodTDateIso().optional(),

    matterport_transfer: z.string().optional(),
    matterport_camera_only: coerceBoolean().optional(),
    matterport_discount_dollars: zodTMoneyOptional(),
    matterport_discount_percentage: coerceOptionalPositiveNumber(),
    matterport_discount_date: zodTDateISODate().optional(),

    discount_skip: coerceBoolean().optional(),
    discount_percentage: z.coerce.number().optional(),
    discount_percentage_date: zodTDateISODate().optional(),
    discount_photos: zodTMoneyOptional(),
    discount_photos_pct: coerceOptionalPositiveNumber(),
    discount_photos_date: zodTDateISODate().optional(),

    local_life: coerceBoolean().optional(),
    tax_exempt: coerceBoolean().optional(),

    package_jonny: coerceBoolean().optional(),
    package_justin: coerceBoolean().optional(),
    package_southstone: coerceBoolean().optional(),

    // TODO: not needed anymore?
    first_hour_photo_revenue: z.coerce.number().optional(),
    first_hour_photo_expense: z.coerce.number().optional(),
    first_hour_interior_revenue: z.coerce.number().optional(),
    first_hour_interior_expense: z.coerce.number().optional(),
    aerial_photo_revenue: z.coerce.number().optional(),
    aerial_video_revenue: z.coerce.number().optional(),
    aerial_photo_video_revenue: z.coerce.number().optional(),
  }),
};

export type TwtCustomerMetadata = ZodVersionedMetadata<typeof TwtCustomerSchema>;

export default class TwtCustomer extends TenantCustomer<TwtCustomerMetadata> {
  get info(): DisplayData[] {
    const info = super.info;

    if (this.metadata.notes) {
      info.push({ name: 'Notes', value: this.metadata.notes, provider: true });
    }

    return info;
  }
}
